import React from 'react';

import PropTypes from 'prop-types';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const DEFAULT_PLACEHOLDER = 'Select an option';

const SelectField = ({
  control,
  label,
  name,
  options,
  disabled = false,
  placeholder = DEFAULT_PLACEHOLDER,
}) => (
  <FormField
    control={control}
    name={name}
    render={({ field }) => (
      <FormItem>
        <FormLabel>{label}</FormLabel>

        <Select disabled={disabled} onValueChange={field.onChange} value={field.value}>
          <FormControl>
            <SelectTrigger className="w-full">
              <SelectValue placeholder={placeholder} />
            </SelectTrigger>
          </FormControl>

          <SelectContent>
            {options.map(({ label: optionLabel, value }) => (
              <SelectItem key={value} value={value}>
                {optionLabel}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <FormMessage />
      </FormItem>
    )}
  />
);

const optionShape = PropTypes.shape({
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  value: PropTypes.string.isRequired,
});

SelectField.propTypes = {
  control: PropTypes.shape({}).isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(optionShape).isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default SelectField;
